import React from 'react';
import './index.css';

const DashboardPage = () => {
	return (
		<div className="app-page-container">
			<div className="app-navbar">
				<div className="app-navbar-text">Dashboard</div>
			</div>
			<div className="app-table-content dashboard-content">
				{/* <div className="link">
					<a href={process.env.REACT_APP_DASHBOARD_LINK_CN} target="_blank">
						中文版：汉小智AI智能客服聊天机器人表现报表
					</a>
				</div> */}
				<div className="link">
					<a href={process.env.REACT_APP_DASHBOARD_LINK_EN} target="_blank">
						English Version：Smart Han AI Chatbot Performance Dashboard
					</a>
				</div>
			</div>
		</div>
	);
};

export default DashboardPage;
